import styled from 'styled-components';
import { FiCheckCircle } from 'react-icons/fi';

const SuccessIcon = styled(FiCheckCircle)`
    font-size: 80px;
    color: ${({ theme }) => theme.success};
`;

export default SuccessIcon;